module.exports = __webpack_public_path__ + "img/61.8909abc5.jpg";